import { render } from "./PromoToolsContainer.vue?vue&type=template&id=4a16b5e0&scoped=true"
import script from "./PromoToolsContainer.vue?vue&type=script&lang=js"
export * from "./PromoToolsContainer.vue?vue&type=script&lang=js"

import "./PromoToolsContainer.vue?vue&type=style&index=0&id=4a16b5e0&scoped=true&lang=css"

import exportComponent from "/builds/platform/frontend/side_panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a16b5e0"]])

export default __exports__